import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

interface UseAddDepartmentMutationOptions {
  companyId: number;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

const useAddDepartmentMutation = ({
  companyId,
  onSuccess,
  onError,
}: UseAddDepartmentMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (body: any[]) => {
      const res = await axiosInstance.put(api.addDepartment(companyId), body);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useAddDepartmentMutation;
